import React, { useState, useEffect } from 'react';
import { Button, Alert, Box } from '@mui/material';
import PortalSnackbar from './Common/PortalSnackbar';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check if app was installed
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setShowInstallPrompt(false);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleClose = () => {
    setShowInstallPrompt(false);
  };

  if (isInstalled) return null;

  return (
    <PortalSnackbar
      open={showInstallPrompt}
      onClose={handleClose}
      sx={{
        top: { xs: 72, sm: 24 },
        bottom: 'auto',
      }}
    >
      <Alert
        onClose={handleClose}
        severity="info"
        variant="filled"
        icon={
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/img/favicon.png`}
            alt=""
            sx={{ width: 24, height: 24, objectFit: 'contain' }}
          />
        }
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleInstallClick}
          >
            Install
          </Button>
        }
      >
        Install Idotoo for a better experience!
      </Alert>
    </PortalSnackbar>
  );
};

export default PWAInstallPrompt;